// extracted by mini-css-extract-plugin
module.exports = {"loadingMessage":"LoadingMessage-loadingMessage-1gR5r"};